var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "history-cnt" }, [
    _c(
      "div",
      {
        class: ["history-fixed", _vm.scrollTop ? "history-fixed-shadow" : ""],
        style: { right: "0px" },
      },
      [
        _c(
          "el-tabs",
          {
            attrs: { type: "card" },
            on: { "tab-remove": _vm.removeTab, "tab-click": _vm.selectTab },
            model: {
              value: _vm.curName,
              callback: function ($$v) {
                _vm.curName = $$v
              },
              expression: "curName",
            },
          },
          _vm._l(_vm.history, function (item, index) {
            return _c("el-tab-pane", {
              key: item.path,
              attrs: {
                label: item.title,
                name: item.path,
                closable: index !== 0,
                index: index,
                "active-menu": item.path,
              },
            })
          }),
          1
        ),
        _vm.cntMenuVisible
          ? _c(
              "div",
              {
                staticClass: "cnt-menu-visible",
                style: {
                  left: _vm.cntMenuLeft + "px",
                  top: _vm.cntMenuTop + "px",
                },
              },
              [
                _c(
                  "p",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.menuBtn("all")
                      },
                    },
                  },
                  [_vm._v("关闭所有标签页")]
                ),
                _c(
                  "p",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.menuBtn("other")
                      },
                    },
                  },
                  [_vm._v("关闭其他标签页")]
                ),
                _c(
                  "p",
                  {
                    class: { grey: _vm.pathIndex === _vm.history.length - 1 },
                    on: {
                      click: function ($event) {
                        return _vm.menuBtn("right")
                      },
                    },
                  },
                  [_vm._v(" 关闭右侧标签页 ")]
                ),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }